/**
 * O login que volta ao destino (DS-638, E-k).
 *
 * O link do aviso leva a pessoa a `/aprovacoes`; sem sessão, o portão do shell a manda para
 * `/entrar?de=%2Faprovacoes`, e depois do segundo fator ela volta para lá. O `de` vem do
 * endereço, e o endereço qualquer um escreve: sem guarda, `/entrar?de=//outro.site` é um
 * redirecionamento aberto com a cara do DigitalView.
 *
 * A guarda compara ORIGEM, não prefixo. O antigo `startsWith('/')` aceitava `//outro.site`, que
 * o navegador lê como outro host. Recusa também, antes de qualquer resolução, o que o navegador
 * reescreve em silêncio: barra invertida (`/\outro.site` vira `//outro.site`) e caractere de
 * controle (o tab e a quebra de linha somem do meio da URL), cru ou codificado. E nunca volta
 * para `/entrar`, que só daria uma volta. Na dúvida, o destino é o cockpit.
 */

const COCKPIT = '/'

/** Caractere de controle ou barra invertida: o que o parser de URL apaga ou troca por `/`. */
const REESCRITO_PELO_NAVEGADOR = /[\u0000-\u001f\u007f\\]/

function decodificado(valor: string): string | null {
  try {
    return decodeURIComponent(valor)
  } catch {
    return null
  }
}

/** O destino de volta, se ele é deste app; senão, o cockpit. Devolve caminho relativo. */
export function destinoSeguro(de: string | null, origem: string): string {
  if (de === null || de === '') return COCKPIT
  if (!de.startsWith('/') || de.startsWith('//')) return COCKPIT
  const legivel = decodificado(de)
  if (legivel === null) return COCKPIT
  if (REESCRITO_PELO_NAVEGADOR.test(de) || REESCRITO_PELO_NAVEGADOR.test(legivel) || legivel.startsWith('//')) return COCKPIT
  let base: URL
  let alvo: URL
  try {
    base = new URL(origem)
    alvo = new URL(de, base)
  } catch {
    return COCKPIT
  }
  if (alvo.origin !== base.origin) return COCKPIT
  if (alvo.pathname === '/entrar' || alvo.pathname.startsWith('/entrar/')) return COCKPIT
  // A SAÍDA também é conferida: o segmento de ponto (`/.//evil.test`, `/a/..//evil.test`, `/%2e//…`)
  // é resolvido depois das guardas da entrada, com a origem do app, mas o caminho normalizado vira
  // `//evil.test`, que o navegador lê como outro host (F8). Devolve-se só o que, relido, fica aqui.
  const saida = `${alvo.pathname}${alvo.search}${alvo.hash}`
  if (saida.startsWith('//') || saida.startsWith('/\\')) return COCKPIT
  if (new URL(saida, base).origin !== base.origin) return COCKPIT
  return saida
}

/**
 * O endereço de `/entrar` que leva o destino junto. O cockpit não precisa ir: sem `de`, a
 * entrada já termina nele.
 */
export function entradaComRetorno(destino: string): string {
  return destino === COCKPIT || destino === '' ? '/entrar' : `/entrar?de=${encodeURIComponent(destino)}`
}
